export default "__VITE_ASSET__BtqxRB5f__"